import Home from './components/Home.vue';
import GalleryOverview from './components/GalleryOverview.vue';
import Gallery from './components/Gallery.vue';
import Shoutout from './components/Shoutout.vue';
import MusicWishlist from './components/MusicWishlist.vue';

export default [
    { 
      path: '/', 
      component: Home,
    },
    { 
      path: '/gallery-overview', 
      component: GalleryOverview,
    },
    { 
      path: '/gallery/:galleryid', 
      component: Gallery,
    },
    { 
      path: '/gallery/:galleryid/:picid', 
      component: Gallery,
    },
    {
      path: "/shoutout",
      component: Shoutout,
    },
    {
      path: "/music-wishlist",
      component: MusicWishlist,
    },
    {
      path: "*",
      redirect: "/"
    }
    
]